import { LIST_COLUMNS } from '../../../types';
import { useColumn } from './useColumn';

export const useColumns = () => {
  const nameColumn = useColumn(LIST_COLUMNS.name);
  const typeColumn = useColumn(LIST_COLUMNS.type);
  const usersColumn = useColumn(LIST_COLUMNS.users, false);
  const lastModifiedByColumn = useColumn(LIST_COLUMNS.lastModifiedBy);
  const overflowMenuColumn = useColumn(LIST_COLUMNS.overflowMenu, false);
  return [nameColumn, typeColumn, usersColumn, lastModifiedByColumn, overflowMenuColumn];
};
